import { useEffect, useState } from 'react';
import type { StockerRobotState } from './stockerTypes';
import { stockerTransferRobotStore, STOCKER_ROBOT_PARKED } from './stockerTransferRobotStore';

/** Subscribe to OHT-transfer-driven lifter pose for a stocker element id. */
export function useStockerTransferRobotState(
  elementId: string | undefined,
  override?: StockerRobotState
): StockerRobotState {
  const [, tick] = useState(0);

  useEffect(() => {
    if (!elementId) return;
    return stockerTransferRobotStore.subscribe(() => tick((n) => n + 1));
  }, [elementId]);

  if (override) return override;
  if (!elementId) return STOCKER_ROBOT_PARKED;
  return stockerTransferRobotStore.get(elementId);
}
